enum CASE_STATUS {
  CLOSED = 'CLOSED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export default CASE_STATUS;
